import { MoreMenu } from "./MoreMenu";
import MenuItem = MoreMenu.MenuItem;
import { S25States } from "../../../services/state/state.map";
import { FlsService } from "../../../services/fls.service";
import { UserprefService } from "../../../services/userpref.service";
import { PreferenceService } from "../../../services/preference.service";
import { Debounce } from "../../../decorators/debounce.decorator";

export class MoreMenuUtil {
    @Debounce(500)
    public static getPreferences() {
        return PreferenceService.getPreferences([
            "config_logo_link",
            "config_feedback_email",
            "pro_dark_mode",
            "TaskHeaderCount",
        ]);
    }

    public static async getNavigateTo(): Promise<MenuItem[]> {
        const fls = await FlsService.getFls();
        const isLoggedIn = await UserprefService.getLoggedIn();

        const navigateTo = [
            S25States.untyped.list,
            S25States.untyped.calendar,
            S25States.untyped.availability,
            S25States.untyped.search,
            S25States.untyped.grids,
            S25States.untyped.optimizerEffectiveDating,
            ...(isLoggedIn && "N" !== fls.REP_LIST ? [S25States.untyped.report] : []),
            S25States.untyped.publisher,
            S25States.untyped.studentEngagement,
            S25States.untyped.systemSettings,
            S25States.untyped.userSettings,
        ];

        return navigateTo
            .filter((item) => !item.isHidden)
            .map((item): MenuItem => {
                if (item.parent === "external") {
                    return { displayName: item.display, url: item.url };
                }

                return { displayName: item.display, state: item };
            });
    }
}
